import VideoPlayer from "components/ai/tools/VideoPlayer";
import CommonHelper from "helpers/CommonHelper";
import styled from "styled-components";

import BlurOverlay from "../BlurOverlay";

const VideoMessage = (props) => {
  const {
    xUrl,
    videoUrl,
    hasSubscription,
    shouldBlur,
    setVideoModalState,
    onUnblurClick,
    url,
    scenario,
    game = {},
    dialog = {}
  } = props;
  return (
    <>
      <PicturePlaceholder>
        {hasSubscription || !shouldBlur ? (
          <VideoPlayer
            size="100%"
            imageUrl={xUrl}
            videoUrl={videoUrl}
            setVideoModalState={setVideoModalState}
          />
        ) : (
          <>
            <PictureInnerPlaceholder src={CommonHelper.getFilesCdnUrl(xUrl)} />
            <BlurOverlay url={url} onUnblurClick={onUnblurClick} scenario={scenario} game={game} dialog={dialog} />
          </>
        )}
      </PicturePlaceholder>
      {/* {!!scenario?.picturesCount && (
        <PicturesCountText>
          {`There are ${scenario.picturesCount} photos in this scenario. Keep chatting to unlock them all!`}
        </PicturesCountText>
      )} */}
    </>
  );
};

export default VideoMessage;


const PicturePlaceholder = styled.div`
  position: relative;
  box-sizing: border-box;
  border-radius: 20px;
  width: calc(min(75vh, 75vw, 320px));
  height: calc(min(75vh, 75vw, 320px));
  margin: 0 auto;
  display: flex;
  align-items: center; 
  justify-content: center;
`;

// const PicturesCountText = styled.div`
//   padding-top: 14px;
//   color: #a9a9a9;
//   text-align: center;
// `;

const PictureInnerPlaceholder = styled.div`
  border-radius: 20px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-image: url(${props => props.src});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: rgb(19, 19, 19);
`;
